import React from 'react';
import type { FC } from 'react';

import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

const globalStyleRules = {
  '*': {
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
  html: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    height: '100%',
    width: '100%',
  },
  body: {
    height: '100%',
    width: '100%',
  },
  '#root': {
    height: '100%',
    width: '100%',
  },
  '@keyframes shimmer': {
    to: {
      backgroundPositionX: '0%',
    },
  },
  '@keyframes fadeSlideUp': {
    from: { opacity: 0, transform: 'translateY(10px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
} as const;

/** Applies global CSS resets and shared keyframe animations for the app shell. */
const GlobalStyles: FC = () => {
  return <MuiGlobalStyles styles={globalStyleRules} />;
};

export default GlobalStyles;
